import { render, staticRenderFns } from "./customer-tree.vue?vue&type=template&id=388ec94f"
import script from "./customer-tree.vue?vue&type=script&lang=js"
export * from "./customer-tree.vue?vue&type=script&lang=js"
import style0 from "./customer-tree.vue?vue&type=style&index=0&id=388ec94f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports